import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from 'react-ga';

let _initialized = false ; 

const trackingId = process.env.REACT_APP_GA_TRACKING_ID ;

/**
 * 
 * Enables Google analytics tracking.
 * Creates and provides an instance of ReactGA (https://github.com/react-ga/react-ga). 
 * Tracking ID must be set in the env REACT_APP_GA_TRACKING_ID
 * 
 * @returns a ReactGA instance 
 * 
 */
const useGoogleAnalytics = () => {

    const location = useLocation() ;

    useEffect( () => {

        if(!_initialized){

            if(!trackingId || trackingId === ''){
                console.warn("No REACT_APP_GA_TRACKING_ID set in env, GA tracking is off");
                return ;
            }

            ReactGA.initialize(trackingId) ;
   
            _initialized = true ;
        }

        console.log(`Route : ${location.pathname}`) ;

        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    
    }, [location]) ;

    return ReactGA ;

}

export default useGoogleAnalytics ;
